var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44728 4.44728C4.73376 4.16089 5.12226 4 5.52734 4C5.93242 4 6.32092 4.16089 6.6074 4.44728L12.0092 9.8491L17.411 4.44728C17.6992 4.169 18.0851 4.01502 18.4856 4.0185C18.8862 4.02198 19.2693 4.18265 19.5526 4.46589C19.8358 4.74913 19.9965 5.13229 19.9999 5.53284C20.0034 5.93339 19.8494 6.31928 19.5712 6.6074L14.1693 12.0092L19.5712 17.411C19.8494 17.6992 20.0034 18.0851 19.9999 18.4856C19.9965 18.8862 19.8358 19.2693 19.5526 19.5526C19.2693 19.8358 18.8862 19.9965 18.4856 19.9999C18.0851 20.0034 17.6992 19.8494 17.411 19.5712L12.0092 14.1693L6.6074 19.5712C6.31928 19.8494 5.93339 20.0034 5.53284 19.9999C5.13229 19.9965 4.74913 19.8358 4.46589 19.5526C4.18265 19.2693 4.02198 18.8862 4.0185 18.4856C4.01502 18.0851 4.169 17.6992 4.44728 17.411L9.8491 12.0092L4.44728 6.6074C4.16089 6.32092 4 5.93242 4 5.52734C4 5.12226 4.16089 4.73376 4.44728 4.44728Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3e72387b6a04baba2bd0b6863387141b.svg";
export { ForwardRef as ReactComponent };